import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PermissionTemplateRequestLineContainerModel } from "../../../../../models/aggregates/permissions/permission-template-request-line-container.model";
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config, Pagination } from "../shared";

@Injectable({
    providedIn: 'root',
})
export class PermissionRequestLineService extends BaseApiTemplateService<PermissionTemplateRequestLineContainerModel> {
    constructor(http: HttpClient){
        super();
        this.httpClient = http;
    }

    private setUrl(endpoint: string): void{
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'permission-template-requests' + endpoint;
        this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'permission-template-requests' + endpoint;
    }

    sysadminPost(dtoObject: PermissionTemplateRequestLineContainerModel, apiVisa: ApiVisa){
        this.setUrl('/sysadmin-ep');
        return super.post(dtoObject, apiVisa);
    }

    sysadminDelete(guid: string, apiVisa: ApiVisa){
        this.setUrl('/sysadmin-ep');
        return super.delete(guid, apiVisa);
    }

    sysadminPut(dtoObject: PermissionTemplateRequestLineContainerModel, apiVisa: ApiVisa){
        this.setUrl('/sysadmin-ep');
        return super.put(dtoObject, apiVisa);
    }

    sysadminGetAll(apiVisa: ApiVisa){
        this.setUrl('/sysadmin-ep');
        return super.get(apiVisa);
    }

    sysadminGetByGuid(guid: string, apiVisa: ApiVisa){
        this.setUrl('/sysadmin-ep');
        return super.getByGuid(guid, apiVisa)
    }

    sysadminGetByCriteria(pagination: Pagination, apiVisa: ApiVisa){
        this.setUrl('/sysadmin-ep');
        return super.getByCriteria(pagination, apiVisa);
    }

    sysadminProcess(guid: string, statusApproval: string, apiVisa: ApiVisa){
        this.setUrl(`/process/sysadmin-ep/${guid}/${statusApproval}`)

        if(this.endpoint_path && apiVisa.api_domain_url){
            this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
        }
        return this.httpClient.put<ApiResponseModel<PermissionTemplateRequestLineContainerModel>>(this.apiUrl, null, this.getHttpHeader(apiVisa));
    }
}